import { Badge as MantineBadge, type BadgeProps as MantineBadgeProps } from '@mantine/core';
import { forwardRef } from 'react';

export type BadgeProps = MantineBadgeProps;

export const Badge = forwardRef<HTMLDivElement, BadgeProps>(function Badge(props, ref) {
  return <MantineBadge ref={ref} {...props} />;
});
